import { CompanyBillingDetails } from './useCompanyBillingDetails';

import { GetCompanyBillingInformationQuery } from '@generated/GetCompanyBillingInformationQuery';

export const computeCPReturnData = (
  data?: GetCompanyBillingInformationQuery
): CompanyBillingDetails => ({
  paymentMethod: data?.getCompanyBillingDetails?.paymentMethod ?? null,
  isDelinquent: data?.getCompanyBillingDetails?.isDelinquent ?? null,
  processoutCustomerId: data?.getCompanyBillingDetails?.processoutId ?? null,
  plan: data?.getCompanyBillingDetails?.plan ?? null,
  subscription: data?.getCompanyBillingDetails?.subscription
    ? {
        billingPeriodStartsAt: data.getCompanyBillingDetails.subscription.billingPeriodStartsAt,
        billingPeriodEndsAt: data.getCompanyBillingDetails.subscription.billingPeriodEndsAt ?? null,
        nextInvoiceAt: data.getCompanyBillingDetails.subscription.nextInvoiceAt,
        recurrence: data.getCompanyBillingDetails.subscription.recurrence,
        isAutoRenewal: data.getCompanyBillingDetails.subscription.isAutoRenewal,
        pricePerAdditionalUser: data.getCompanyBillingDetails.subscription.pricePerAdditionalUser,
        totalIncludedUsers: data.getCompanyBillingDetails.subscription.totalIncludedUsers,
        maxAdditionalUsers: data.getCompanyBillingDetails.subscription.maxAdditionalUsers,
        billingFrequencyAddUserNumber:
          data.getCompanyBillingDetails.subscription.billingFrequencyAddUserNumber,
        currency: data.getCompanyBillingDetails.subscription.currency,
      }
    : null,
});
